import React, {ReactNode} from 'react';
import styled from 'styled-components';
import {tokens} from "../../../../theme";

const TileButtonStyled = styled.button<{ $disable?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
    width: 120px;
    
    border-radius: 15%;
    border: 1px solid ${({ theme }) => theme.palette.dividers.strong};
    
    background: ${({ theme }) => theme.palette.background.input};
    pointer-events: ${({$disable}) => ($disable ? 'none' : 'auto')};

    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${tokens.fontSize.sm};
    font-weight: ${tokens.fontWeight.semibold};
    
    label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    &:hover, &:hover > * {
        cursor: pointer;
    }

    &:hover {
        background: ${({ theme }) => theme.palette.action.hoveredBackground};
    }
`

const TileButton = ({children, $disable, onClick}: { children: ReactNode, $disable?: boolean, onClick?: () => void }) => {
    return (
        <TileButtonStyled $disable={$disable} onClick={onClick}>
            {children}
        </TileButtonStyled>
    );
};

export default TileButton;

